import React, { createContext, useContext, useState } from 'react';

type SideNavState = {
	isSideNavOpen: boolean;
	setSideNavOpen: (isOpen: boolean) => void;
};

const SideNavContext = createContext<SideNavState | undefined>(undefined);

export const SideNavProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [isSideNavOpen, setSideNavOpen] = useState(false);

	return (
		<SideNavContext.Provider value={{ isSideNavOpen, setSideNavOpen }}>
			{children}
		</SideNavContext.Provider>
	);
};

export const useSideNav = (): SideNavState => {
	const context = useContext(SideNavContext);
	if (context === undefined) {
		throw new Error('useSideNav must be used within a SideNavProvider');
	}
	return context;
};
